module.exports = __webpack_public_path__ + "static/media/bootstrap-icon.87d99487.png";